const ROOTS = {
  BU: '/:bu',
  EVENT: '/:event',
  AUTH: '/auth',
  USER: '/user',
  HOME: '/home',
  BENEFITS: '/benefits',
  PARKING: '/parking',
};

export const paths = {
  root: `${ROOTS.BU}${ROOTS.EVENT}/`,
  auth: {
    root: `${ROOTS.BU}${ROOTS.EVENT}${ROOTS.AUTH}`,
    login: `${ROOTS.BU}${ROOTS.EVENT}${ROOTS.AUTH}/login`,
    loginPreview: `${ROOTS.BU}${ROOTS.EVENT}${ROOTS.AUTH}/login-preview`,
    registerPreview: `${ROOTS.BU}${ROOTS.EVENT}${ROOTS.AUTH}/register-preview`,
  },

  // PLOP.JS COMMENT BELOW FOR SCRIPTS, PLEASE DON'T REMOVE
  // PAGES

  parkingReceipt: {
    root: (id: string) => `${ROOTS.BU}${ROOTS.EVENT}${ROOTS.PARKING}/receipt/${id}`,
  },

  parking: {
    root: (id: string) => `${ROOTS.BU}${ROOTS.EVENT}${ROOTS.PARKING}/${id}`,
  },

  wifi: {
    root: '/wifi',
  },

  user: {
    root: `${ROOTS.BU}${ROOTS.EVENT}${ROOTS.USER}`,
    profile: `${ROOTS.BU}${ROOTS.EVENT}${ROOTS.USER}/profile`,
  },

  benefits: {
    root: `${ROOTS.BU}${ROOTS.EVENT}${ROOTS.BENEFITS}`,
    satisfactionSurvey: `${ROOTS.BU}${ROOTS.EVENT}${ROOTS.BENEFITS}/:benefitId/satisfaction-survey`,
  },

  home: {
    root: `${ROOTS.BU}${ROOTS.EVENT}${ROOTS.HOME}`,
  },

  error: {
    notFound: '/404',
    forbidden: '/403',
    serverError: '/500',
  },
};
